import React from 'react';
import {useStyles} from "./styles/CardStyle";
import InfoCard from "./InfoCard";
import {useMediaQuery} from "@material-ui/core";

export default function Info() {
    const classes = useStyles();
    const isMobile = useMediaQuery("(max-width: 1000px)");

    return (
        <div>
            <div className={isMobile ? classes.mobileBar : classes.bar}>
                <h3 className={classes.heading} style={{textAlign :'left'}}>Please feel free to ask any questions you may have.
                </h3>
                <p className={classes.info} style={{textAlign: 'left'}}>
                    If you have any inquiries about the PMING application, please write your questions.<br/>
                    Using email will allow you to receive a quicker response.
                </p>
            </div>
            <InfoCard isMobile={isMobile}/>
        </div>
    );
}
